module.exports = __webpack_public_path__ + "static/media/UserDiscount.01d94963.svg";